export default "__VITE_ASSET__13cb54fb__"